<template>
    <div class="left-menu x-height-100" :style="{width: leftWidth}" data-automation="leftMenu">
        <div :class="['content', {'border': border}]">
            <slot></slot>
        </div>
        <div v-if="showCut" class="telescopic x-flex-center" @click="telescopic">
            <i class="mask"></i>
            <i :class="['iconfont ux_icon_arrow_right x-grey-text', {'left': leftWidth === '0px' ? true : false}]"></i>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'MyLeftMenu',
      props: {
        width: {
          type: String,
          default: '300px'
        },
        border: { // 是否有边框
          type: Boolean,
          default: true
        },
        showCut: { // 是否有切换按钮
          type: Boolean,
          default: true
        }, 
      },
      data() {
        return {
          leftWidth: this.width
        };
      },

      methods: {
        /**
             * 展开伸缩
             */
        telescopic() {
          this.leftWidth = this.leftWidth === this.width ? '0px' : this.width;
        }
      },
      watch: {
        width(val) {
          this.leftWidth = val;
        },
      }
    };
</script>

<style lang="scss" scoped>
    .left-menu {
        position: relative;
        transition: all 0.3s ease-in;
        background-color: #fff;

        .border {
            border-right: 1px solid #D7DDE780;
        }

        .content {
            width: 100%;
            height: 100%;
            overflow: hidden;
            white-space: nowrap;
        }

        .telescopic {
            position: absolute;
            top: 50%;
            left: 100%;
            transform: translateY(-50%);
            cursor: pointer;

            .mask {
                width: 0;
                height: 26px;
                border-left: 12px solid #e8e8e8;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
            }

            .iconfont {
                position: absolute;
                left: -1px;
                font-size: 12px;
                transform: rotateY(180deg);
            }

            .left {
                transform: rotateY(360deg);
            }
        }
    }
</style>

